<template>
  <div
    class="quick-add"
    :class="[{ 'quick-add--sizes-shown': sizesAreShown }, modifier ? `quick-add--${modifier}` : '']"
    @mouseleave="hideModals"
  >
    <div
      class="quick-add__position-absolute-container"
      :class="{ 'quick-add__position-absolute-container--sizes-shown': sizesAreShown }"
    >
      <Sizes
        :variant="variant"
        :variantSkus="variant.skus || []"
        :variantIsSock="variantIsSock"
        :isBackorderable="isBackorderable"
        :imageUrl="imageUrl"
        :productName="productName"
        :productType="productType"
        :isInsideQuickAdd="true"
        @select-size="handleSelectSize"
      />
    </div>
    <button
      class="quick-add__button"
      :class="{ 'quick-add__button--sizes-shown': sizesAreShown }"
      @mouseenter="showSizes"
      @click.prevent="showSizes"
    >
      <span class="quick-add__plus icon-plus"></span>
      {{ this.buttonText }}
    </button>
  </div>
</template>

<script>
import getPageContext from '@/helpers/page-context'
import updateCartMixin from '@/mixins/update-cart'
import Sizes from '@/components/_shared/Sizes/Sizes.vue'

export default {
  name: 'QuickAdd',
  components: { Sizes },
  mixins: [updateCartMixin],

  props: {
    variant: { type: Object, required: true },
    onSizesPanelChange: { type: Function, default: function() {} },
    buttonText: { type: String, required: true, default: '' },
    modifier: { type: String, required: false, default: '' },
  },

  data() {
    return {
      sizesAreShown: false,
    }
  },

  computed: {
    variantIsSock() {
      if (!this.variant.spreeProduct) return false
      return this.variant.spreeProduct.groupName.match(/Sock/) ? true : false
    },

    isBackorderable() {
      return this.variant.isBackorderable ? true : false
    },

    imageUrl() {
      if (!this.spreeProduct) return ''
      return this.variant.imageUrl
    },

    productName() {
      if (!this.spreeProduct) return ''
      return this.variant.spreeProduct.groupName
    },

    productType() {
      if (!this.spreeProduct) return ''
      return this.variant.spreeProduct.productType
    },

    spreeProduct() {
      return this.variant.spreeProduct
    },
  },

  watch: {
    sizesAreShown() {
      this.onSizesPanelChange(this.sizesAreShown)
    },
  },

  methods: {
    hideModals() {
      this.sizesAreShown = false
    },

    showSizes() {
      this.sizesAreShown = true
    },

    handleSelectSize(selectedSize, $event) {
      const selectedSku = this.variant.skus.find(sku => sku.size === selectedSize)
      if ($event) this.updateCart(selectedSku, getPageContext($event))
    },
  },
}
</script>

<style lang="scss">
@import './quick-add';
</style>
